<template>
  <div v-if="roomData && !isLoading">
    <PhotoWall :imgUrls="roomData.room[0].imageUrl"></PhotoWall>
    <div class="wrapper">
      <div class="item-1">
        <roomInfo :roomInfo="roomData.room[0]"></roomInfo>
      </div>
      <div class="item-2">
        <BookingCard></BookingCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import roomInfo from "@/components/roomInfo.vue";
import PhotoWall from "@/components/PhotoWall.vue";
import BookingCard from "@/components/BookingCard.vue";
export default {
  components: { roomInfo, PhotoWall, BookingCard },
  created() {
    this.$store.dispatch("getRoomByID", this.$route.params.id);
  },
  computed: {
    ...mapState(["isLoading", "roomData"])
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
}
@media (max-width: 875px) {
  .wrapper {
    flex-flow: column;
    align-items: center;
  }
}
</style>
